<template>
  <v-container fluid class="mt-n3">
    <v-card flat class="disable-scrollbars">
      <v-card-text>
        <v-row style="min-height: 20px">
          <v-col
            class="text-center mt-n3"
            cols="12"
            sm="12"
            md="12"
            lg="12"
            xs="12"
          >
            <line-chart :chartdata="chartdata" :options="options"></line-chart>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import ChartFilter from "./filter_components/ChartFilter";
import datasetsReports from "../../../../../services/datasetsReports";

export default {
  name: "ChartFilterContainer",
  components: { "line-chart": ChartFilter },
  data: () => ({
    loaded: true,
    chartdata: {
      labels: datasetsReports.eDayMonth(),
      datasets: [
        {
          label: "Montante",
          fill: true,
          backgroundColor: "rgba(54,162,235,0.29)",
          borderColor: "rgb(75, 192, 192)",
          stack: "Stack 0",
          data: datasetsReports.eAmount()
        }
      ]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      hover: {
        mode: "nearest",
        intersect: true
      },
      tooltips: {
        mode: "index",
        intersect: false
      }
    }
  }),
  methods: {},
  created() {
    //this.total();
  }
};
</script>

<style scoped></style>
